<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="business" title="Business" src="/images/sub/subvisual-business.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section id="business-roadmap" class="page-section--first">
            <template #title>
                Business Roadmap
            </template>

            <v-img :aspect-ratio="1200 / 1046" src="/images/sub/business/roadmap-img-en.png" data-aos="fade" />
        </page-section>

        <page-section-image id="business-solution" imageSrc="/images/sub/business/business-img.jpg">
            <template #title>
                <h4 class="tit tit--lg">IReis’s self-developed crop growth solution</h4>
            </template>
            <template #text>
                <p>We provide our own self-developed solution through continuous research on crops in order to realize sustainable agriculture.</p>
                <p>Our solution promotes crops’ healthy growth and enables crop cultivation of constant quality and amount. </p>
            </template>
        </page-section-image>

        <page-section-image id="business-facility" imageSrc="/images/sub/business/business-img2.jpg" reverse>
            <template #title>
                <h4 class="tit tit--lg">IReis smart farm facilities that enhance agricultural productivity</h4>
            </template>
            <template #text>
                <p>Our smart farm facilities enable various types of agriculture regardless of region.</p>
                <p>With our own technology and products based on extensive experience and expertise, we install smart farm facilities that optimize the crop growth environment.</p>
                <p>We contribute to a sustainable future by introducing eco-friendly production facilities.</p>
            </template>
        </page-section-image>

        <page-section-image id="business-crop" imageSrc="/images/sub/business/business-img3.jpg">
            <template #title>
                <h4 class="tit tit--lg">Smart farm technology-intensive cultivation system</h4>
            </template>
            <template #text>
                <p>You can cultivate healthy plants in an efficient way with our own self-developed products and technologies.</p>
                <p>Our system helps plants grow optimally by monitoring the growth environment in real time and controlling environmental factors such as temperature, humidity, and root zone measurement.</p>
            </template>
        </page-section-image>

        <page-section-image id="business-distribution" class="page-section--last" imageSrc="/images/sub/business/business-img4.jpg" reverse>
            <template #title>
                <h4 class="tit tit--lg">Distribution of fresher and healthier agricultural products</h4>
            </template>
            <template #text>
                <p>You can buy or enjoy fresh agricultural products cultivated in IReis-operated smart farms or cooperative farms at supermarkets, department stores, and franchise restaurants.</p>
                <p>Agricultural products cultivated with IReis’s technology boast of excellent quality and freshness obtained through thorough quality management. Safe and healthy agricultural products are supplied to consumers.</p>
            </template>
        </page-section-image>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import PageSectionImage from "@/pages/client/templates/page-section-image.vue";
import UTabs from "@/components/dumb/u-tabs.vue";
import UTab from "@/components/dumb/u-tab.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        PageSectionImage,
        UTabs,
        UTab,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
